import React from 'react';
import { Container, Row, Col } from 'react-bootstrap'; // Import necessary Bootstrap components
import plearning from "../../Assets/Allows-Learners-to-Take-Control.png";

function Contact() {
  return (
    <Container fluid className="about-section">
      <Row style={{ justifyContent: "center", padding: "100px" }}>
        <div className="quote-card-view">
          <div className="contact-info">
            <h1>Contact Information:</h1>
            <h4 style={{ color: 'yellow' }}>Email: varshini.balaji@creativethee.com</h4>
            <br/>
            <br/>
          </div>
        </div>
        {/* <Col md={5} style={{ paddingTop: "120px", paddingBottom: "50px" }} className="about-img">
          <img src={plearning} alt="about" className="img-fluid" />
        </Col> */}

        {/* Embed the first Google Form */}
        <Col md={6}>
        <iframe title="Volunteer with Us" src="https://docs.google.com/forms/d/e/1FAIpQLSfLqQa_7xMbTjIoKRQMvt7D_QmKg9b-dxWtvYaxIkvvTCFxVw/viewform?embedded=true" width="640" height="1806" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe>
          {/* <iframe
            
            src=""
            width="100%"
            height="600"
            frameBorder="0"
            marginHeight="0"
            marginWidth="0"
          >
            Loading...
          </iframe> */}
        </Col>

        {/* Embed the second Google Form */}
        <Col md={6}>
        <iframe title="Share your Thoughts" src="https://docs.google.com/forms/d/e/1FAIpQLSfP3qaSkeA8tVJqC7Y5AjePaN03eUSoGIaF_otov_O2Xh_CEA/viewform?embedded=true" width="640" height="2170" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe>
          {/* <iframe
            title="Share your Thoughts"
            src="https://forms.gle/1hX9SaKPR3niXpsx8"
            width="100%"
            height="600"
            frameBorder="0"
            marginHeight="0"
            marginWidth="0"
          >
            Loading...
          </iframe> */}
        </Col>
      </Row>
    </Container>
  );
}

export default Contact;
